import { AssignmentStudentEntity } from "../../../meta-data/app-meta-data.service";


export const studentAssignmentProgress = 'studentAssignmentProgress';

export interface StudentAssignmentProgressEvent {
    data: AssignmentStudentEntity;
}
